import { render, staticRenderFns } from "./VisibilityOffIcon.vue?vue&type=template&id=8fa823a4&scoped=true&"
import script from "./VisibilityOffIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./VisibilityOffIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa823a4",
  null
  
)

export default component.exports